import { createApp } from 'vue'
import App from './App.vue'
import router from './router';
import { createPinia } from 'pinia';
import PiniaStore from './store/index.js';
import './assets/tailwind.css';

const app = createApp(App);

app.use(createPinia());
app.use(PiniaStore);
app.use(router);
app.mount('#app');